const BUNDLE_BUILDER_SESSION_KEY = "bundleBuilderSession";

export const getBundleBuilderSession = () => {
  try {
    const raw = sessionStorage.getItem(BUNDLE_BUILDER_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.anchorProductId || !parsed?.shopId) return null;
    return {
      anchorProductId: String(parsed.anchorProductId),
      shopId: String(parsed.shopId),
      selection:
        parsed.selection && typeof parsed.selection === "object"
          ? parsed.selection
          : {},
    };
  } catch {
    return null;
  }
};

export const saveBundleBuilderSession = ({ anchorProductId, shopId, selection }) => {
  if (!anchorProductId || !shopId) return;
  try {
    sessionStorage.setItem(
      BUNDLE_BUILDER_SESSION_KEY,
      JSON.stringify({
        anchorProductId: String(anchorProductId),
        shopId: String(shopId),
        selection: selection && typeof selection === "object" ? selection : {},
      })
    );
  } catch {
    // ignore quota / private mode errors
  }
};

export const clearBundleBuilderSession = () => {
  try {
    sessionStorage.removeItem(BUNDLE_BUILDER_SESSION_KEY);
  } catch {
    // ignore
  }
};

export const buildReturnToBundleUrl = (anchorProductId) =>
  `/product/${anchorProductId}?openBundle=1`;
